import type { TIrrigationSchedulerStoreState } from 'App/irrigation-scheduler/utils/store/irrigationSchedulerStore'
import { irrigationSchedulerStore } from 'App/irrigation-scheduler/utils/store/irrigationSchedulerStore'
import type { TFieldAssetStoreState } from 'stores/fieldAssetStore/fieldAssetStore'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import { getValidIrrigationSchedulerEmitters } from './getValidIrrigationSchedulerEmitters'

export const getValidIrrigationZoneEmittersForPropertyForIrrigationScheduler = (
  fass: TFieldAssetStoreState = fieldAssetStore.getState(),
  isss: TIrrigationSchedulerStoreState = irrigationSchedulerStore.getState(),
) => {
  const propertyEmitters = isss.selectedPropertyId
    ? (fass.properties?.[Number(isss.selectedPropertyId)]?.irrigationZoneEmitters ?? {})
    : {}

  return getValidIrrigationSchedulerEmitters(propertyEmitters)
}
